import { getPropertyOf } from '@cs/core';

export class SubFilterItem {
  label: string;
  isDismissible: boolean;
  id: string;

  constructor(init: Partial<SubFilterItem>) {
    this.id            = getPropertyOf(init, 'id');
    this.label         = getPropertyOf(init, 'label');
    this.isDismissible = getPropertyOf(init, 'isDismissible', true);
  }
}
